import clsx from 'clsx';
import {
  ArrowTrendingUpIcon,
  ArrowTrendingDownIcon,
  ArrowRightIcon,
} from '@heroicons/react/24/outline';
import { getTrendColor } from '@/utils/format';
import type { ConcentrationTrend, TrendConfidence } from '@/types';

interface TrendBadgeProps {
  trend: ConcentrationTrend;
  confidence?: TrendConfidence;
  size?: 'sm' | 'md' | 'lg';
  showConfidence?: boolean;
}

const TREND_ICONS = {
  increasing: ArrowTrendingUpIcon,
  stable: ArrowRightIcon,
  decreasing: ArrowTrendingDownIcon,
};

const TREND_LABELS = {
  increasing: 'INCREASING',
  stable: 'STABLE',
  decreasing: 'DECREASING',
};

const CONFIDENCE_OPACITY = {
  high: 'opacity-100',
  medium: 'opacity-70',
  low: 'opacity-40',
};

export function TrendBadge({
  trend,
  confidence = 'medium',
  size = 'md',
  showConfidence = false,
}: TrendBadgeProps) {
  const Icon = TREND_ICONS[trend];

  const sizeClasses = {
    sm: { wrapper: 'gap-1 text-[10px]', icon: 'h-3 w-3' },
    md: { wrapper: 'gap-1.5 text-xs', icon: 'h-3.5 w-3.5' },
    lg: { wrapper: 'gap-2 text-sm', icon: 'h-4 w-4' },
  };
  const s = sizeClasses[size];

  return (
    <span
      className={clsx(
        'inline-flex items-center tracking-wider font-medium',
        getTrendColor(trend),
        CONFIDENCE_OPACITY[confidence],
        s.wrapper
      )}
    >
      <Icon className={s.icon} />
      {TREND_LABELS[trend]}
      {showConfidence && (
        <span className="text-mono-500 font-normal ml-1">
          ({confidence})
        </span>
      )}
    </span>
  );
}
